import { Component } from "react";
import { connect } from "react-redux";
import SearchInventory from "./searchInventory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import InventoryTable from "./inventory-table";
import NewInventoryItemModal from "./new-Inventory-item-modal";
import { showNewInventoryModal } from "../redux-state/features/inventory/inventorySlice";
import InventoryNavBar from "./navBar";
import AddNewInventoryNames from "./add-new-names";
import PrintQrCodeModal from "./print-QrCode-modal";
import CreateRoomsInventory from "./createRoomsInventoryModal";
class Inventory extends Component {
  render() {
    return (
      <div>
        <PrintQrCodeModal />
        <AddNewInventoryNames />
        <NewInventoryItemModal />
        <InventoryNavBar />

        <CreateRoomsInventory />
        <h5 style={{ display: "flex", alignItems: "center" }}>
          إدارة الجرد
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid black",
              marginRight: "8px",
            }}
          ></span>
        </h5>
        {/* <div className="d-flex  justify-content-between mt-3">
          <SearchInventory />
          <button
            className="btn btn-warning"
            onClick={() => this.props.showNewInventoryModal()}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" />
            <span className="ms-2">إضافة جرد جديد </span>
          </button>
        </div> */}
        <hr />
        <InventoryTable />
      </div>
    );
  }
}

const mapDispatchToProps = { showNewInventoryModal };
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
